module.exports = __webpack_public_path__ + "img/notice-bg-lowerRight.af99d804.png";